import { render, staticRenderFns } from "./TheArrowDownIcon.vue?vue&type=template&id=76b0974e&"
import script from "./TheArrowDownIcon.vue?vue&type=script&lang=js&"
export * from "./TheArrowDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports